module.exports = __webpack_public_path__ + "img/ico-my-tv.605a0ad0.png";